/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 70864546c2b8255bd60d15ee520521ae */

import { ConcreteRequest } from "relay-runtime";

export type CountryCode = "AE" | "AR" | "AT" | "AU" | "BE" | "BG" | "BR" | "CA" | "CH" | "CL" | "CN" | "CO" | "CR" | "CZ" | "DE" | "DK" | "EC" | "EE" | "EG" | "ES" | "FI" | "FL" | "FR" | "GB" | "GR" | "GT" | "HR" | "HU" | "IE" | "IN" | "IT" | "JP" | "KE" | "KR" | "LT" | "LU" | "LV" | "MA" | "MX" | "MY" | "NL" | "NO" | "NZ" | "PA" | "PE" | "PL" | "PT" | "RO" | "SA" | "SE" | "SG" | "SI" | "SK" | "TN" | "TR" | "UA" | "UK" | "UM" | "US" | "VG" | "VI" | "ZA" | "%future added value";
export type CurrencyCode = "CAD" | "EUR" | "GBP" | "INR" | "MXN" | "USD" | "%future added value";
export type DigitalRiverCreditCardBrand = "AMERICAN_EXPRESS" | "DISCOVER" | "MASTERCARD" | "VISA" | "%future added value";
export type DigitalRiverPaymentSourceState = "CANCELLED" | "CHARGEABLE" | "CONSUMED" | "FAILED" | "PENDING_FUNDS" | "PENDING_REDIRECT" | "REQUIRES_ACTION" | "%future added value";
export type DigitalRiverPaymentType = "CREDIT_CARD" | "PAYPAL" | "%future added value";
export type DigitalRiverShippingServiceLevel = "EXPRESS_2_DAY" | "EXPRESS_NEXT_DAY" | "STANDARD_GROUND" | "%future added value";
export type DigitalRiverCheckoutCreateInput = {
    checkoutItems: Array<DigitalRiverCheckoutItemInput>;
};
export type DigitalRiverCheckoutItemInput = {
    quantity: number;
    sku: string;
};
export type CartRoutesCreateMutationVariables = {
    input: DigitalRiverCheckoutCreateInput;
    digitalRiverBillingId: string;
};
export type CartRoutesCreateMutationResponse = {
    readonly digitalRiverCheckoutCreate: {
        readonly errors: ReadonlyArray<{
            readonly message: string | null;
            readonly field: ReadonlyArray<string | null> | null;
        }> | null;
        readonly digitalRiverCheckout: {
            readonly id: string | null;
            readonly createdAt: string | null;
            readonly updatedAt: string | null;
            readonly shipTo: {
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly email: string | null;
                readonly organization: string | null;
                readonly address: {
                    readonly addressLine1: string | null;
                    readonly addressLine2: string | null;
                    readonly city: string | null;
                    readonly stateProvinceRegionCode: string | null;
                    readonly zipPostalCode: string | null;
                    readonly countryCode: CountryCode | null;
                    readonly mailingAddressName: string | null;
                    readonly contactName: string | null;
                } | null;
            } | null;
            readonly billTo: {
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly email: string | null;
                readonly organization: string | null;
                readonly address: {
                    readonly addressLine1: string | null;
                    readonly addressLine2: string | null;
                    readonly city: string | null;
                    readonly stateProvinceRegionCode: string | null;
                    readonly zipPostalCode: string | null;
                    readonly countryCode: CountryCode | null;
                    readonly mailingAddressName: string | null;
                    readonly contactName: string | null;
                } | null;
            } | null;
            readonly currency: CurrencyCode | null;
            readonly lineItems: ReadonlyArray<{
                readonly lineItemId: string | null;
                readonly sku: string | null;
                readonly quantity: number | null;
                readonly amount: {
                    readonly amount: unknown | null;
                    readonly currencyCode: CurrencyCode | null;
                } | null;
            } | null> | null;
            readonly paymentSource: {
                readonly paymentSourceId: string | null;
                readonly paymentSessionId: string | null;
                readonly clientSecret: string | null;
                readonly state: DigitalRiverPaymentSourceState | null;
                readonly currency: CurrencyCode | null;
                readonly type: DigitalRiverPaymentType | null;
                readonly creditCard: {
                    readonly lastFourDigits: string | null;
                    readonly expirationMonth: number | null;
                    readonly expirationYear: number | null;
                    readonly brand: DigitalRiverCreditCardBrand | null;
                } | null;
                readonly payPalBillingToken: string | null;
            } | null;
            readonly shippingChoice: {
                readonly price: {
                    readonly amount: unknown | null;
                    readonly currencyCode: CurrencyCode | null;
                } | null;
                readonly serviceLevel: DigitalRiverShippingServiceLevel | null;
            } | null;
            readonly taxRate: number | null;
            readonly totalShipping: {
                readonly amount: unknown | null;
                readonly currencyCode: CurrencyCode | null;
            } | null;
            readonly subTotal: {
                readonly amount: unknown | null;
                readonly currencyCode: CurrencyCode | null;
            } | null;
            readonly tax: {
                readonly amount: unknown | null;
                readonly currencyCode: CurrencyCode | null;
            } | null;
            readonly total: {
                readonly amount: unknown | null;
                readonly currencyCode: CurrencyCode | null;
            } | null;
        } | null;
    } | null;
};
export type CartRoutesCreateMutation = {
    readonly response: CartRoutesCreateMutationResponse;
    readonly variables: CartRoutesCreateMutationVariables;
};



/*
mutation CartRoutesCreateMutation(
  $input: DigitalRiverCheckoutCreateInput!
  $digitalRiverBillingId: ID!
) {
  digitalRiverCheckoutCreate(input: $input, digitalRiverBillingId: $digitalRiverBillingId) {
    errors {
      message
      field
    }
    digitalRiverCheckout {
      id
      createdAt
      updatedAt
      shipTo {
        firstName
        lastName
        email
        organization
        address {
          addressLine1
          addressLine2
          city
          stateProvinceRegionCode
          zipPostalCode
          countryCode
          mailingAddressName
          contactName
        }
      }
      billTo {
        firstName
        lastName
        email
        organization
        address {
          addressLine1
          addressLine2
          city
          stateProvinceRegionCode
          zipPostalCode
          countryCode
          mailingAddressName
          contactName
        }
      }
      currency
      lineItems {
        lineItemId
        sku
        quantity
        amount {
          amount
          currencyCode
        }
      }
      paymentSource {
        paymentSourceId
        paymentSessionId
        clientSecret
        state
        currency
        type
        creditCard {
          lastFourDigits
          expirationMonth
          expirationYear
          brand
        }
        payPalBillingToken
      }
      shippingChoice {
        price {
          amount
          currencyCode
        }
        serviceLevel
      }
      taxRate
      totalShipping {
        amount
        currencyCode
      }
      subTotal {
        amount
        currencyCode
      }
      tax {
        amount
        currencyCode
      }
      total {
        amount
        currencyCode
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "digitalRiverBillingId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "organization",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Address",
    "kind": "LinkedField",
    "name": "address",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "addressLine1",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "addressLine2",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stateProvinceRegionCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zipPostalCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "countryCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mailingAddressName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "contactName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  }
],
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "digitalRiverBillingId",
        "variableName": "digitalRiverBillingId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DigitalRiverCheckoutPayload",
    "kind": "LinkedField",
    "name": "digitalRiverCheckoutCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DigitalRiverCheckout",
        "kind": "LinkedField",
        "name": "digitalRiverCheckout",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DigitalRiverShipTo",
            "kind": "LinkedField",
            "name": "shipTo",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DigitalRiverBillTo",
            "kind": "LinkedField",
            "name": "billTo",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DigitalRiverCheckoutLineItem",
            "kind": "LinkedField",
            "name": "lineItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lineItemId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sku",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quantity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Money",
                "kind": "LinkedField",
                "name": "amount",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DigitalRiverPaymentSource",
            "kind": "LinkedField",
            "name": "paymentSource",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentSourceId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentSessionId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientSecret",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DigitalRiverCreditCard",
                "kind": "LinkedField",
                "name": "creditCard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastFourDigits",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expirationMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expirationYear",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "brand",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "payPalBillingToken",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DigitalRiverShippingChoice",
            "kind": "LinkedField",
            "name": "shippingChoice",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Money",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceLevel",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Money",
            "kind": "LinkedField",
            "name": "totalShipping",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Money",
            "kind": "LinkedField",
            "name": "subTotal",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Money",
            "kind": "LinkedField",
            "name": "tax",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Money",
            "kind": "LinkedField",
            "name": "total",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CartRoutesCreateMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CartRoutesCreateMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "id": "70864546c2b8255bd60d15ee520521ae",
    "metadata": {},
    "name": "CartRoutesCreateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = 'f2f77d4bfb9ea34f4e1c20826795b34a';
export default node;
